module.exports = __webpack_public_path__ + "static/media/pinterest.38a6cbf6.svg";